import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';
import moment from "moment";
class ResponseMaker {
    data = [];
    data_to_send = {
        totalOrderList: 0,
        orderList: {}
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data.payload.total !== undefined) {
            this.data_to_send.totalOrderList = this.data.payload.total
        }
        if (this.data.payload.orderList !== undefined && this.data.payload.orderList.length > 0) {
            let value = [];
            this.data.payload.orderList.map((v, i) => {
                let here_v = {}
                if (v['sapOrderNumber']) {
                    here_v.orderNumber = v['sapOrderNumber'] === '' || v['sapOrderNumber'] === null || v['sapOrderNumber'] === 'N/A' ? v['webOrderNum'] : v['sapOrderNumber']
                }
                if (v['sapOrderNumber']) {
                    here_v.sapOrderNumber = v['sapOrderNumber']
                }
                if (v['purchaseOrderNumber']) {
                    here_v.purchaseOrderNumber = v['purchaseOrderNumber']
                }
                if (v['webOrderNum']) {
                    here_v.webOrderNumber = v['webOrderNum']
                }
                if (v['lineItemNumber']) {
                    here_v.lineItemNumber = v['lineItemNumber']
                }
                if (v['manufacturerName']) {
                    here_v.manufacturerName = v['manufacturerName']
                }
                if (v['manufacturerPartNumber']) {
                    here_v.manufacturerPartNumber = v['manufacturerPartNumber']
                }
                if (v['itemNumber']) {
                    here_v.itemNumber = v['itemNumber']
                }
                if (v['productShortDescription']) {
                    here_v.productShortDescription = v['productShortDescription']
                }
                if (v['customerPartNumber']) {
                    here_v.customerPartNumber = v['customerPartNumber']
                }
                if (v['confirmedQuantity']) {
                    here_v.confirmedQuantity = v['confirmedQuantity']
                }
                if (v['totalQuantity']) {
                    here_v.totalQuantity = v['totalQuantity']
                }
                if (v['requestedQuantity']) {
                    here_v.requestedQuantity = v['requestedQuantity']
                }
                if (v['requestedDate']) {
                    here_v.requestedDate = v['requestedDate']
                    here_v.finalRequestedDate = Helper.dateFormatFromString(v['requestedDate'])
                }
                if (v['confirmedDate']) {
                    here_v.confirmedDate = v['confirmedDate']
                    here_v.finalConfirmedDate = Helper.dateFormatFromString(v['confirmedDate'])
                }
                if (v['orderStatus']) {
                    here_v.orderStatus = v['orderStatus'].toLowerCase() === 'pending' ? 'Order Pending' : v['orderStatus']
                }
                if (v['shippedQuantity']) {
                    here_v.shippedQuantity = v['totalItemLineQuantity']
                }
                if (v['deliveryNumber']) {
                    here_v.deliveryNumber = v['deliveryNumber']
                }
                if (v['trackingNumber']) {
                    here_v.trackingNumber = v['trackingNumber']
                }
                if (v['currency']) {
                    here_v.currency = v['currency']
                }
                if (v['price']) {
                    here_v.price = v['price']
                }
                if (v['priceBasedQuantity']) {
                    here_v.priceBasedQuantity = v['priceBasedQuantity']
                }
                if (v['currencyFluctuation']) {
                    here_v.currencyFluctuation = v['currencyFluctuation']
                    if (v['currencyFluctuation'] !== '' && v['currencyFluctuation'].toUpperCase() === 'Y') {
                        here_v.currencyFluctuation = 'Yes'
                    }
                    if (v['currencyFluctuation'] !== '' && v['currencyFluctuation'].toUpperCase() === 'N') {
                        here_v.currencyFluctuation = 'No'
                    }
                }
                if (v['cfCurrency']) {
                    here_v.cfCurrency = v['cfCurrency']
                }
                if (v['cfAgreedRate']) {
                    here_v.cfAgreedRate = v['cfAgreedRate']
                }
                if (v['itemTotalPrice']) {
                    here_v.itemTotalPrice = v['itemTotalPrice']
                }
                if (v['invoiceNumber']) {
                    here_v.invoiceNumber = v['invoiceNumber']
                }
                if (v['orderCreationDate']) {
                    here_v.orderCreationDate = v['orderCreationDate']
                    here_v.finalOrderCreationDate = Helper.dateFormatFromString(v['orderCreationDate'])
                }
                if (v['carrier']) {
                    here_v.carrier = v['carrier']
                }
                if (v['orderDate']) {
                    here_v.orderDate = v['orderDate']
                    here_v.finalOrderDate = Helper.dateFormatFromString(v['orderDate'])
                }
                if (v['orderStatusName']) {
                    here_v.orderStatusName = v['orderStatusName']
                }

                if (v['netValue']) {
                    here_v.netValue = v['netValue']
                } else {
                    here_v.netValue = 0
                }

                if (v['orderType']) {
                    here_v.orderType = v['orderType'];
                }
                if (v['customerAccountNumber']) {
                    here_v.customerAccountNumber = v['customerAccountNumber']
                }
                if (v['mfr']) {
                    here_v.manufacturer = v['mfr']
                }
                if (v['buyerName']) {
                    here_v.buyerName = v['buyerName']
                }
                if (v['trackingUrl']) {
                    here_v.trackingUrl = v['trackingUrl'];
                }
                if (v['pO_Line_Item_Number']) {
                    here_v.poLineItemNumber = v['pO_Line_Item_Number'];
                }
                if (v['matnr']) {
                    here_v.matnr = v['matnr']
                }

                if (v['zetenr']) {
                    here_v.zetenr = v['zetenr'];
                }
                else {
                    here_v.zetenr = "";
                }
                /**17630 - Return Req Pop-up add field for manufacturer code & name */
                here_v.isReturnReq = false;
                if (v['deliveryDate'] && (v['orderStatus']?.toLowerCase() === 'shipped' || v['orderStatus']?.toLowerCase() === 'partially shipped' || v['orderStatus']?.toLowerCase() === 'invoiced')) {
                    const twelveMonthsLater = moment(v['deliveryDate']).add(12, 'months').format('MM/DD/YYYY');
                    here_v.isReturnReq = moment().isBefore(twelveMonthsLater);
                }
                if (v['erpManufacturerCode']) {
                    here_v.erpManufacturerCode = v['erpManufacturerCode']
                }
                if (v['erpManufacturerName']) {
                    here_v.erpManufacturerName = v['erpManufacturerName']
                }
                here_v.assetURL = '';
                if(v['thumbnailPath']) {
                    here_v.assetURL = v['thumbnailPath'];
                }
                here_v.deliveryDate = v['deliveryDate'] ? Helper.dateFormatFromString(v['deliveryDate']) : ''
                // if (v['itemLines'] && v['itemLines'].length > 0) {
                //     let finalItems = []
                //     v['itemLines'].map((j, i) => {
                //         let here_j = {}
                //         if (j.lineItemNumber) {
                //             here_j.lineItemNumber = j.lineItemNumber
                //         }
                //         if (j.manufacturer) {
                //             here_j.manufacturer = j.manufacturer
                //         }
                //         if (j.manufacturerName) {
                //             here_j.manufacturerName = j.manufacturerName
                //         }
                //         if (j.manufacturerPartNumber) {
                //             here_j.manufacturerPartNumber = j.manufacturerPartNumber
                //         }
                //         if (j.customerPartNumber) {
                //             here_j.customerPartNumber = j.customerPartNumber
                //         }
                //         if (j.qtyOrdered) {
                //             here_j.quantity = j.qtyOrdered
                //         } else {
                //             here_j.quantity = 0
                //         }
                //         if (j.qtyDelivered) {
                //             here_j.deliveredQuantity = j.qtyDelivered
                //         } else {
                //             here_j.deliveredQuantity = 0
                //         }
                //         if (j.priceLineTotal) {
                //             here_j.price = j.priceLineTotal
                //         } else {
                //             here_j.price = 0
                //         }
                //         if (j.pricePerUnit) {
                //             here_j.unitPrice = j.pricePerUnit
                //         } else {
                //             here_j.unitPrice = 0
                //         }
                //         if (j.currency) {
                //             here_j.currency = j.currency
                //         }
                //         if (j.scheduledDate) {
                //             here_j.scheduledDate = j.scheduledDate
                //             here_j.finalScheduledDate = Helper.dateFormatFromString(j['scheduledDate'])
                //         }
                //         if (j.deliveryDate) {
                //             here_j.deliveryDate = j.deliveryDate
                //             here_j.finalDeliveryDate = Helper.dateFormatFromString(j['deliveryDate'])
                //         }
                //         if (j.status) {
                //             here_j.status = j.status.toLowerCase() === 'pending' ? 'Order Placed' : j.status
                //         }
                //         if (j.orderType) {
                //             here_j.orderType = j.orderType
                //         }

                //         finalItems.push(here_j)
                //     })
                //     here_v.items = finalItems
                // }

                value[i] = here_v;
            })

            this.data_to_send.orderList = value
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;